import React from "react";
import { Box, SpaceBetween, Badge } from "@cloudscape-design/components";
import { BadgeColor } from "src/constants/reportConstants";

interface FiltersDisplayProps {
  filters: Record<string, any>;
  labelWidth?: string;
  title?: string;
}

/**
 * Displays applied filters in a structured format with badges
 * @param filters - Object mapping filter names to their selected values
 * @param labelWidth - Width of filter labels
 * @param title - Section title
 */
export const FiltersDisplay: React.FC<FiltersDisplayProps> = ({ 
  filters, 
  labelWidth = "120px",
  title = "Filters"
}) => {
  const renderFilterValue = (value: any): string => {
    if (Array.isArray(value)) return value.join(', ');
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    if (value == null) return 'Not specified';
    return String(value);
  };

  return (
    <Box>
      <Box variant="h3" margin={{ bottom: "s" }}>{title}</Box>
      <SpaceBetween direction="vertical" size="xs">
        {Object.entries(filters).map(([key, values]) => {
          const valueArray = Array.isArray(values) ? values : [values];
          return (
            <SpaceBetween key={key} direction="horizontal" size="s">
              <div style={{ minWidth: labelWidth }}>
                <Box variant="strong" fontSize="body-s">
                  {key}:
                </Box>
              </div>
              <SpaceBetween direction="horizontal" size="xs">
                {valueArray.map((value, index) => (
                  <Badge key={index} color={BadgeColor.SEVERITY_NEUTRAL}>
                    {renderFilterValue(value)}
                  </Badge>
                ))}
              </SpaceBetween>
            </SpaceBetween>
          );
        })}
      </SpaceBetween>
    </Box>
  );
};
